export const isAutosuggestionVisible = (
  open,
  value,
  suggested,
  showSuggestionMinAmount
) =>
  open &&
  value &&
  value?.length >= showSuggestionMinAmount &&
  suggested.length > 0;

export const isTooManyMatches = (open, value, showSuggestionMinAmount) =>
  open && value && value?.length > 0 && value?.length < showSuggestionMinAmount;

export const isNoMatchFoundVisible = (
  open,
  value,
  suggested,
  showSuggestionMinAmount
) =>
  open &&
  !!value?.length &&
  value?.length >= showSuggestionMinAmount &&
  suggested.length === 0;
